<ng-select *ngIf="!disable" [items]="locations" bindLabel="location_Name" bindValue="id" [virtualScroll]="true"
           placeholder="{{_placeholder}}" [(ngModel)]="locationId" (ngModelChange)="onChanged()" [selectOnTab]="true">
</ng-select>
<input *ngIf="disable" type="text" [(ngModel)]="location_Name" style="width:100%" class="form-control" [disabled]="true" />
